export default __webpack_public_path__ + "static/media/sunspot-galaxy.cadeb796c38d2eb19097e305ad3cb262.svg";